'use client'

import { Radar, ArrowRight } from 'lucide-react'

export default function RadarCTA() {
  return (
    <div data-blog-layout='narrow' className='my-8'>
      <a
        href='/platform'
        data-cta-id='blog_radar'
        className='block !no-underline !decoration-transparent group'
      >
        <div
          className='relative overflow-hidden rounded-2xl p-8 md:p-10 transition-transform duration-200 hover:scale-[1.01]'
          style={{
            background: 'linear-gradient(135deg, #8b5cf6, #F90B8A, #FDC304)',
          }}
        >
          <div className='flex items-center gap-8'>
            <div className='flex-1 min-w-0'>
              <span className='inline-block text-[11px] font-bold tracking-[1.5px] uppercase text-white/80 mb-3'>
                Free brand check
              </span>
              <h3 className='text-xl md:text-2xl font-extrabold text-white leading-tight mt-0 mb-3'>
                Is AI making things up about your brand?
              </h3>
              <p className='text-sm md:text-[15px] text-white/85 leading-relaxed mb-5 mt-0'>
                Radar scans the major AI answer engines in 60 seconds, flags
                hallucinations, finds missing citations, and gives you a ranked
                fix list. The same 13 tools we used to fix our own AI
                visibility.
              </p>
              <div className='flex flex-wrap items-center gap-4'>
                <span className='inline-flex items-center gap-2 bg-white text-[#8b5cf6] px-5 py-2.5 rounded-lg font-semibold text-sm group-hover:bg-white/95 transition-colors'>
                  Check your brand free
                  <ArrowRight size={16} />
                </span>
                <a
                  href='/platform#pricing'
                  data-cta-id='blog_radar_pricing'
                  className='text-sm text-white/80 hover:text-white underline underline-offset-2 !decoration-white/40'
                  onClick={e => e.stopPropagation()}
                >
                  See pricing
                </a>
              </div>
            </div>
            <div className='hidden md:flex items-center justify-center w-28 h-28 bg-white/15 rounded-2xl flex-shrink-0'>
              <Radar size={48} className='text-white/90' />
            </div>
          </div>
        </div>
      </a>
    </div>
  )
}
